import * as SagaType from '../../constants/constant_saga_types';

const INITIAL_STATE = {
  records: [],
  context: null,
};

export default function recordTypesReducer( state = INITIAL_STATE, action ) {
  switch ( action.type ) {
    case SagaType.DONE_FETCH_RECORD_TYPES: {
      return {
        ...action.payload
      }
    }
    default:
      return state;
  }
}